import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import makeStyles from '@material-ui/styles/makeStyles';

import PayUInfoWithTooltip from '../PayUInfoWithTooltip';

const useStyles = makeStyles({
  title: {
    display: 'flex',
    gap: '4px',
    marginLeft: '15px',
  },
  domainAssociation: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    margin: '15px 15px 0',
  },
  domainAssociationHint: {
    margin: 0,
    fontSize: '0.875rem',
    color: '#777',
  },
});

const PayUModule = ({ handleModuleUpdate, module }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const classes = useStyles();

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          replace: 'PayUModule',
        })}
      </div>
    );
  }

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <h3 className={classes.title}>
            {t('paymentType.title.PayU')} <PayUInfoWithTooltip />
          </h3>
        </GridItem>
      </GridContainer>
      <GridItem xs={6}>
        <NumberFormat
          label={t('paymentType.payUModule.oAuthClientId')}
          customInput={FormTextInput}
          value={module.clientId}
          onChange={e =>
            handleModuleUpdate({ ...module, clientId: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <NumberFormat
          label={t('paymentType.payUModule.paymentPointId')}
          customInput={FormTextInput}
          value={module.posId}
          onChange={e =>
            handleModuleUpdate({ ...module, posId: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.payUModule.oAuthClientSecret')}
          name="payUClientSecret"
          value={module.clientSecret}
          handleChange={e =>
            handleModuleUpdate({ ...module, clientSecret: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.payUModule.md5Key')}
          name="payUmd5Key"
          value={module.md5Key}
          handleChange={e =>
            handleModuleUpdate({ ...module, md5Key: e.target.value })
          }
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.payUModule.googlePayId')}
          name="payUGooglePayMerchantId"
          value={module.googlePayMerchantId}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              googlePayMerchantId: e.target.value,
            });
          }}
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={6}>
        <FormTextInput
          label={t('paymentType.payUModule.applePayId')}
          name="payUApplePayMerchantId"
          value={module.applePayMerchantId}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              applePayMerchantId: e.target.value,
            });
          }}
          inputSize={12}
        />
      </GridItem>
      <GridItem xs={12}>
        <div className={classes.domainAssociation}>
          <Button
            color="info"
            size="sm"
            onClick={() => history.push('/admin/access-keys')}
          >
            {t('paymentType.payUModule.applePayDomainAssociation.accessKeys')}
          </Button>
          <p className={classes.domainAssociationHint}>
            {t('paymentType.payUModule.applePayDomainAssociation.hint')}
          </p>
        </div>
      </GridItem>
      <GridItem xs={12}>
        <FormTextInput
          label={t(
            'paymentType.payUModule.applePayMerchantIdentityCertificate'
          )}
          name="payUApplePayMerchantIdentityCertificate"
          value={module.applePayMerchantIdentityCertificate}
          handleChange={e => {
            handleModuleUpdate({
              ...module,
              applePayMerchantIdentityCertificate: e.target.value,
            });
          }}
          inputSize={12}
          maxLength="none"
          multiline={true}
          rows={4}
          rowsMax={12}
        />
      </GridItem>
    </>
  );
};

export default PayUModule;
